export const kk = {
  'hx': {
    'all': 'Барлығы',
    'atol': {
      'taxationType': {
        'esn': 'бірыңғай ауыл шаруашылығы салығы',
        'osn': 'жалпы',
        'patent': 'патенттік салық салу жүйесі',
        'usnIncome': 'жеңілдетілген, кіріс',
        'usnIncomeOutcome': 'жеңілдетілген, кіріс минус шығыс'
      }
    },
    'bank-account-select': {
      'placeholder': {
        'selectBank': 'Банк шотын таңдаңыз'
      }
    },
    'bank-select': {
      'selectBank': 'Банкті таңдаңыз'
    },
    'brand-select': {
      'selectBrand': 'Брендті таңдаңыз'
    },
    'btn': {
      'apply': 'Қолдану',
      'back': 'Артқа',
      'cancel': 'Бас тарту',
      'close': 'Жабу',
      'save': 'Сақтау'
    },
    'call-audio': {
      'play': 'Ойнату'
    },
    'city-select': {
      'selectCity': 'Қаланы таңдаңыз'
    },
    'client-checker': {
      'bonus': 'Бонустар',
      'mobileNum': 'Тек ұялы нөмірлер',
      'ng': {
        'clear': 'Тазалау'
      },
      'placeholder': {
        'num': 'Жаңа'
      },
      'addBirthDateNote': 'Туған күнін қосу'
    },
    'client-edit-modal': {
      'changeProfile': 'Клиент профилін өзгерту',
      'profile': 'Клиенттің жаңа профилі'
    },
    'client-edit': {
      'activeCoins': 'Бонустар',
      'btn': {
        'addMail': 'E-mail қосу',
        'addNote': 'Ескертпе қосу',
        'addPhone': 'Телефон қосу'
      },
      'client': 'Клиент деректері',
      'coin': {
        'th': {
          'activationDate': 'Басталу күні',
          'amount': 'Саны',
          'expireDate': 'Аяқталу күні',
          'operation': 'Операция'
        }
      },
      'coins': 'Бонустар',
      'comment': {
        'title': 'Пікірлер',
        'date': 'Күні',
        'actor': 'Автор'
      },
      'happyDay': 'Туған күні',
      'info': 'Қосымша ақпарат',
      'mobileNum': 'Тек ұялы нөмірлер',
      'mobileNumber': 'Ұялы нөмір',
      'name': 'Аты-жөні',
      'ng': {
        'change': 'Өзгерту',
        'delete': 'Жою',
        'deleteContact': 'Байланысты жою'
      },
      'num': 'Телефон нөмірі',
      'table': {
        'body': {
          'blacklist': 'қара тізімде'
        },
        'head': {
          'blacklist': 'Қара тізім',
          'brand': 'Бренд',
          'note': 'Ескертпе'
        }
      },
      'ts': {
        'clientExists': 'Бұл нөмірмен клиент бар',
        'commentEmpty': 'Пікірлер толтырылмаған',
        'dataUpdated': 'Деректер жаңартылды',
        'error': 'Қате орын алды',
        'mail': 'Электрондық пошта',
        'phone': 'Телефон',
        'textNum': 'Ұялы телефон нөмірін енгізіңіз'
      }
    },
    'client-indicator': {
      'nb': {
        'blacklist': 'қара тізім: {{ blackListInfo }}',
        'note': 'ескертпелер: {{client}}'
      }
    },
    'client-list': {
      'title': 'Клиенттер',
      'subtitle': 'Профильдер, байланыстар және туған күндер бір жерде',
      'total': 'Барлық клиенттер',
      'scope': 'қолжетімді дүкендерде',
      'scopeBrandCountry': 'Таңдалған бренд пен елдің клиенттері',
      'results': 'Клиенттер тізімі',
      'filtered': 'Таңдалған шарттарға сәйкес клиенттер',
      'unfiltered': 'Сізге қолжетімді барлық клиенттер',
      'pageSize': 'Беттегі жол саны',
      'clear': 'Сүзгілерді тазалау',
      'loading': 'Клиенттер жүктелуде…',
      'emptyTitle': 'Клиенттер табылмады',
      'emptyFiltered': 'Іздеуді немесе туған күн сүзгісін өзгертіп көріңіз.',
      'emptyUnfiltered': 'Қолжетімді дүкендерде әзірше клиенттер жоқ.',
      'emptyBrandCountry': 'Бұл бренд пен ел үшін әзірше клиенттер жоқ.',
      'noName': 'Аты жоқ',
      'noPhone': 'Телефоны жоқ',
      'open': 'Клиентті ашу',
      'months': {'1': 'Қаңтар', '2': 'Ақпан', '3': 'Наурыз', '4': 'Сәуір', '5': 'Мамыр', '6': 'Маусым', '7': 'Шілде', '8': 'Тамыз', '9': 'Қыркүйек', '10': 'Қазан', '11': 'Қараша', '12': 'Желтоқсан'},
      'btn': {'search': 'Іздеу'},
      'filter': {'birthDate': 'Туған күні', 'day': 'Күн', 'month': 'Ай', 'brand': 'Бренд', 'country': 'Ел', 'anyDay': 'Кез келген күн', 'anyMonth': 'Кез келген ай', 'query': 'Іздеу'},
      'placeholder': {'name': 'Аты-жөні немесе телефон нөмірі'},
      'table': {'head': {'happyDay': 'Туған күні', 'name': 'Аты-жөні', 'num': 'Телефон'}},
      'ng': {'change': 'Өзгерту', 'time': 'Өзгертілген уақыты: {{date}} (Астана уақыты)'},
      'loadError': 'Клиенттерді жүктеу мүмкін болмады. Қайталап көріңіз.',
      'errorId': 'Қате коды: {{id}}',
      'retry': 'Қайта жүктеу'
    },
    'client-profile': {
      'saveError': 'Клиентті сақтау мүмкін болмады. Телефон нөмірін тексеріп, қайталап көріңіз.',
      'contacts': 'Қосымша байланыстар', 'noContacts': 'Қосымша байланыстар жоқ',
      'noProperties': 'Бренд бойынша жазбалар жоқ', 'noCoins': 'Бонустық операциялар жоқ', 'noComments': 'Пікірлер жоқ',
      'phonePlaceholder': 'Телефон нөмірі', 'invalidContact': 'Қосымша телефонды немесе email-ді тексеріңіз.',
      'invalidEmail': 'Жарамды email енгізіңіз', 'invalidPhone': 'Толық телефон нөмірін енгізіңіз',
      'chooseDate': 'Күнді таңдаңыз', 'clearDate': 'Күнді тазалау', 'previousMonth': 'Алдыңғы ай',
      'nextMonth': 'Келесі ай', 'year': 'Туған жылы', 'page': '{{page}}-бет',
      'previousPage': 'Алдыңғы бет', 'nextPage': 'Келесі бет'
    },
    'client-property-edit-modal': {
      'blacklisted': 'Қара тізімде',
      'brand': 'Бренд',
      'no': 'Жоқ',
      'note': 'Ескертпе',
      'title': 'Клиент бойынша ескертпе',
      'ts': {
        'save': 'Деректер сақталды'
      },
      'yes': 'Иә'
    },
    'client-search': {
      'placeholder': {
        'loading': 'Ізделуде…',
        'nameClient': 'Клиенттің атын немесе телефонын енгізіңіз',
        'noFind': 'Табылмады',
        'startSearch': 'Іздеу үшін теруді бастаңыз'
      }
    },
    'closed': 'Жабық',
    'cmp': {
      'gis-address': {
        'hasNoDelivery': 'Жеткізбейміз'
      }
    },
    'comment-add': {
      'mention': 'Белгіні таңдасаңыз, қосымша хабарландыру жіберіледі'
    },
    'comment-list': {
      'actor': 'Автор',
      'addComment': 'Пікір қосу',
      'comment': 'Пікір',
      'date': 'Күні',
      'previous': 'алдыңғы'
    },
    'company': {
      'address': 'Мекенжай',
      'contract': 'Негіздеме',
      'letterOfAuthorityDate': 'Күні',
      'letterOfAuthorityFile': {
        'uploaded': 'Сенімхат жүктелді!',
        'uploadRequired': 'Сенімхатты жүктеу қажет!'
      },
      'letterOfAuthorityFileId': 'Сенімхат',
      'letterOfAuthorityFileLink': {
        'tooltip': 'Жүктелген сенімхатты қарау'
      },
      'letterOfAuthorityNumber': 'Нөмірі',
      'representativeFullname': 'Аты-жөні',
      'saveForAuthorityForm': 'Компания деректерін сақтаңыз',
      'title': 'Атауы',
      'uin': 'БСН'
    },
    'confirm': {
      'cancel': 'Бас тарту',
      'ok': 'ОК',
      'title': 'Әрекетті растау'
    },
    'country-select': {
      'placeholder': {
        'chooseCountry': 'Елді таңдаңыз'
      }
    },
    'data-select': {
      'btn': {
        'close': 'Жабу',
        'today': 'Бүгін'
      }
    },
    'date-range-select': {
      'lastMonth': 'Өткен ай',
      'lastQuarter': 'Өткен тоқсан',
      'lastWeek': 'Өткен апта',
      'month': 'Ай',
      'quarter': 'Тоқсан',
      'week': 'Апта'
    },
    'daterangepicker': {
      'lastMonth': 'Өткен ай',
      'lastQuarter': 'Өткен тоқсан',
      'lastWeek': 'Өткен апта',
      'month': 'Ай',
      'quarter': 'Тоқсан',
      'week': 'Апта'
    },
    'dictionary-select': {
      'placeholder': {
        'selectExpense': 'Шығын түрін таңдаңыз'
      }
    },
    'diff': {
      'deliveryType': {
        'DELIVERY': 'Жеткізушімен жеткізу',
        'PICKUP': 'Өзі алып кету'
      },
      'is': {
        'false': 'алып тастады',
        'happy': {
          'apps': {
            'vanilla': {
              'event': {
                'dto': {
                  'OrderDiffDto': {
                    'action': 'Әрекет',
                    'address': 'Мекенжай',
                    'bookedClient': 'Брондаған клиент',
                    'cartExpireDate': 'Себет уақыты',
                    'cartRangeId': 'Жеткізу уақыты (себет)',
                    'cashless': 'Қолма-қол ақшасыз',
                    'cityId': 'Қала',
                    'clientCash': 'Қолма-қол ақша',
                    'clientId': 'Клиент',
                    'currency': 'Валюта',
                    'date': 'Күні',
                    'decor': 'Безендіру',
                    'decored': 'Безендірілді',
                    'decorText': 'Безендіру',
                    'deliveryLatitude': 'Ендік',
                    'deliveryLongitude': 'Бойлық',
                    'deliveryRangeId': 'Жеткізу уақыты',
                    'deliveryTimeRange': 'Жеткізуші үшін уақытты нақтылау',
                    'deliveryType': 'Жеткізу түрі',
                    'deliveryUserId': 'Жеткізуші',
                    'employeeId': 'Қызметкерге жеңілдік',
                    'enabled': 'Белсенді',
                    'entrance': 'Кіреберіс',
                    'fiscalDate': 'Фиск. күні',
                    'flat': 'Пәтер',
                    'floor': 'Қабат',
                    'important': 'Таңдаулы',
                    'inscription': 'Жазу',
                    'invoice': 'Шот-фактура',
                    'locked': 'Бұғатталған',
                    'modifyDate': 'Өзгертілген күні',
                    'modifyUserId': 'Өзгертті',
                    'note': 'Ескертпе',
                    'number': 'Нөмір',
                    'operationType': 'Операция түрі',
                    'organizationTitle': 'Ұйым атауы',
                    'organizationUin': 'Ұйымның ЖСН/БСН',
                    'paid': 'Төлем күйі',
                    'paidActor': 'Төлемді қабылдады',
                    'parentOrderId': 'Негізгі тапсырыс',
                    'payment': 'Төлем',
                    'paymentDate': 'Төлем күні',
                    'paymentUserFullname': 'Төлемді қабылдады',
                    'paymentUserId': 'Төлемді қабылдады (id)',
                    'phone': 'Телефон',
                    'rahmet': 'Рахмет',
                    'removed': 'Жойылған',
                    'revoked': 'Қайтарылған',
                    'seen': 'Қаралды',
                    'seenUserIds': 'Кім қарады',
                    'senim': 'SENIM',
                    'sourceFrom': 'Тапсырыс дереккөзі',
                    'status': 'Күй',
                    'storeId': 'Дүкен',
                    'storePaymentType': 'Төлем түрі',
                    'subTotal': 'Барлығы',
                    'taxNumber': 'Салық нөмірі',
                    'taxSeries': 'Салық режимі',
                    'taxSum': 'Салық сомасы',
                    'total': 'Барлығы',
                    'underSalary': 'Жалақыдан ұстау күйі',
                    'uniqueNumber': 'Бірегей нөмір',
                    'wkCashboxFactoryNumber': 'МЗН',
                    'wkCashboxRegistrationNumber': 'МТН',
                    'wkCashboxTaxNumber': 'Фискалдық нөмір',
                    'wkFiscalNumber': 'ФБ'
                  }
                }
              }
            }
          },
          'dao': {
            'hc': {
              'dto': {
                'payment': {
                  'PaymentInfoDto': {
                    'payment/cash': 'Қолма-қол ақша',
                    'payment/checkingAccount': 'Төлем тапсырмасы',
                    'payment/dept': 'Қарыз',
                    'payment/forte': 'FortePay',
                    'payment/halyk': 'HalykPay',
                    'payment/kaspi': 'kaspi.kz',
                    'payment/pos': 'POS',
                    'payment/rahmet': 'Рахмет',
                    'payment/senim': 'Senim'
                  }
                }
              }
            }
          }
        },
        'paid': {
          'false': 'төленбеген',
          'true': 'төленді'
        },
        'true': 'қосты'
      },
      'kind': {
        'A': 'тізімге қосты',
        'D': 'жойды',
        'E': 'өзгертті',
        'N': 'қосты'
      },
      'path': {
        'address': 'Мекенжай',
        'callId': 'Қоңырау жазбасы',
        'cash': 'Қолма-қол ақша',
        'cashless': 'Қолма-қол ақшасыз',
        'checkingAccountFileId': 'Төлем тапсырмасы',
        'city': 'Қала',
        'clientCash': 'Қолма-қол ақша',
        'clientId': 'Клиент',
        'clientType': 'Клиент түрі',
        'courier': 'Жеткізуші',
        'date': 'Күні',
        'decorText': 'Безендіру',
        'deliveryLatitude': 'Ендік',
        'deliveryLongitude': 'Бойлық',
        'deliveryTimeRange': 'Жеткізуші үшін уақытты нақтылау',
        'deliveryType': 'Жеткізу түрі',
        'discounts': 'Жеңілдіктер',
        'employeeId': 'Қызметкерге жеңілдік',
        'entrance': 'Кіреберіс',
        'files': 'Файлдар',
        'flat': 'Пәтер',
        'floor': 'Қабат',
        'from': 'Тапсырыс дереккөзі',
        'important': 'Таңдаулы',
        'invoice': 'Шот-фактура',
        'note': 'Ескертпе',
        'paid': 'Төлем күйі',
        'paymentType': 'Төлем түрі',
        'phone': 'Телефон',
        'products': 'Өнімдер',
        'rahmet': 'Рахмет',
        'reason': 'Себебі',
        'senim': 'SENIM',
        'store': 'Дүкен',
        'subTotal': 'Барлығы',
        'total': 'Барлығы',
        'underSalary': 'Жалақыдан ұстау күйі'
      }
    },
    'enum-select': {
      'placeholder': {
        'choose': 'Таңдаңыз'
      }
    },
    'enum': {
      'AccountType': {
        'BANK_ACCOUNT': 'Қолма-қол ақшасыз',
        'CASH': 'Қолма-қол ақша'
      },
      'AccrualType': {
        'DAILY': 'күн сайын',
        'HOURLY': 'сағаттық',
        'MONTHLY': 'ай сайын'
      },
      'CoinOperation': {
        'CANCELLED': 'Бас тартылды',
        'EARNED': 'Есептелді',
        'SPENT': 'Жұмсалды'
      },
      'ComponentType': {
        'cb': 'Касса',
        'cc': 'Call-орталық',
        'cf': 'Кондитерлік',
        'delivery': 'Жеткізуші',
        'kiosk': 'Киоск',
        'manager': 'Менеджер',
        'profile': 'Профиль'
      },
      'Currency': {
        'AZN': 'manat',
        'EUR': 'euro',
        'KGS': 'сом',
        'KZT': 'теңге',
        'RUB': 'рубль',
        'USD': 'dollar',
        'UZS': 'so\'m'
      },
      'EmployeeType': {
        'EMPLOYEE': 'тұрақты келісімшарт',
        'TEMP': 'уақытша келісімшарт'
      },
      'Gender': {
        'FEMALE': 'Ә',
        'MALE': 'Е'
      },
      'InvoiceStatus': {
        'ACCEPTED': 'қабылданды',
        'CANCELLED': 'бас тартылды',
        'DISCARDED': 'есептен шығарылды',
        'INVENTORY': 'түгендеу',
        'NEW': 'құрылды',
        'REJECTED': 'қабылданбады',
        'RESTORATION': 'қалпына келтіру',
        'SENT': 'жіберілді',
        'SHIPMENT': 'жолда'
      },
      'MaritalStatus': {
        'DIVORCED': 'ажырасқан',
        'MARRIED': 'тұрмысқа шыққан/үйленген',
        'SINGLE': 'тұрмысқа шықпаған/үйленбеген',
        'WIDOWED': 'жесір'
      },
      'OperationType': {
        'ADJUSTMENT': 'Түзету',
        'COLLECTION': 'Инкассация',
        'PURCHASE': 'Сатып алу',
        'WITHDRAWAL': 'Ақша алу'
      },
      'PaymentType': {
        'CASH': 'Қолма-қол ақша',
        'CHECKING_ACCOUNT': 'Төлем тапсырмасы',
        'COIN': 'Бонустар',
        'DEBT': 'Қарыз',
        'FORTE': 'Forte',
        'HALYK': 'Halyk',
        'KASPI': 'kaspi',
        'KASPI_POS': 'kaspi POS',
        'PAYBOX': 'Paybox',
        'POS': 'POS',
        'RAHMET': 'Рахмет',
        'SENIM': 'SENIM',
        'UZ_PAYBOX': 'Paybox VM'
      },
      'ProductStatus': {
        'CANCELLED': 'бас тартылды',
        'CART': 'себет',
        'CART_CANCELLED': 'бас тартылды',
        'DISCARDED': 'есептен шығарылды',
        'PAID_CANCELLED': 'бас тартылды',
        'RECEIVED': 'жеткізілді',
        'REFUNDED': 'қайтарым',
        'REGISTER': 'тіркелді',
        'RESERVED': 'құрылды',
        'TRANSFER': 'жіберілді'
      },
      'SourceSystem': {
        'CALLCENTER': 'Call-орталық',
        'CASHBOX': 'Касса',
        'CONFECTIONARY': 'Кондитерлік',
        'INSTAGRAM': 'Instagram',
        'KIOSK': 'Киоск',
        'MANAGER': 'Менеджер',
        'ONLINE': 'Сайт',
        'ONLINE_APP': 'Қосымша',
        'TELEGRAM': 'Telegram бот',
        'WEBKASSA': 'webkassa',
        'WHATSAPP': 'Whatsapp'
      },
      'StorageInvoiceStatus': {
        'ACCEPTED': 'қабылданды',
        'CANCELLED': 'бас тартылды',
        'NEW': 'құрылды',
        'REJECTED': 'қабылданбады',
        'SENT': 'жіберілді'
      },
      'TimeInterval': {
        'day': 'Күні',
        'month': 'Ай',
        'week': 'Апта',
        'year': 'Жыл'
      },
      'TimesheetType': {
        'ABSENCE': 'Себепсіз болмау',
        'ATTENDANCE': 'Келу',
        'HOLIDAY': 'Мереке',
        'SICK': 'Ауру демалысы',
        'VACATION': 'Демалыс'
      }
    },
    'error-handler': {
      'balance': '{{msg}} дүкенінде келесі өнімдердің қалдығын толықтырыңыз: {{product}}',
      'limit': 'Өнімдер бойынша лимит асып кетті: {{product}}'
    },
    'event-diff': {
      'changeData': 'Өзгертілген күні',
      'changeOrder': 'Тапсырысты өзгертті',
      'noChange': 'Өзгеріс жоқ',
      'table': {
        'body': {
          'num': 'дана'
        },
        'head': {
          'after': 'Кейін',
          'before': 'Бұрын'
        }
      },
      'title': 'Тапсырыс өзгертулерінің тарихы',
      'ts': {
        'discount': 'жеңілдік: {{pi}}'
      }
    },
    'event': {
      'COIN_EARNED': 'бонус есептелді',
      'COMPANY_INFO_SAVED': 'заңды тұлға деректері',
      'FISCALIZATION_REFUND': 'чек (қайтарым)',
      'FISCALIZATION_SELL': 'чек',
      'none': 'анықталмаған',
      'ORDER_ARCHIVED': 'мұрағатталды',
      'ORDER_CANCELLED': 'бас тартылды',
      'ORDER_COMPLETED': 'аяқталды',
      'ORDER_CREATED': 'құрылды',
      'ORDER_CURBSIDE_PICKUP': 'жол жиегіне шығару',
      'ORDER_CURBSIDE_PICKUP_SEEN': 'жол жиегіне шығару [касса]',
      'ORDER_DECORED': 'безендірілді',
      'ORDER_INITED': 'тіркелді',
      'ORDER_MODIFIED': 'өзгертілді',
      'ORDER_MODIFYING': 'өзгерту басталды',
      'ORDER_PACKED': 'буылды',
      'ORDER_PAID': 'төленді',
      'ORDER_RECEIVED': 'жеткізілді',
      'ORDER_REFUNDED': 'қайтарым',
      'ORDER_RETURNED': 'босатылды',
      'ORDER_SHIPPED': 'жолда',
      'ORDER_TAKEN': 'қабылдады',
      'ORDER_TRANSFERRED': 'ауыстырылды',
      'ORDER_UNARCHIVED': 'мұрағаттан шығарылды',
      'PAY_INVOICE_SENT': 'төлемге шот',
      'PAYMENT_INVOICE_GENERATED': 'төлемге шот',
      'PAYMENT_STARTED': 'төлем басталды',
      'PRODUCT_INVOICE_GENERATED': 'қорларды сыртқа босату жүкқұжаты',
      'PRODUCT_REFUNDED': 'ішінара қайтарым',
      'PUSH_NOTIFICATION_CREATED': 'push-хабарлама',
      'SERVICE_INVOICE_GENERATED': 'орындалған жұмыстар актісі (көрсетілген қызметтер)',
      'SMS_NOTIFICATION_CREATED': 'смс құрылды',
      'SMS_NOTIFICATION_SENT': 'смс жіберілді',
      'ORAL_ORDER_SELL': 'Oral Gateway-ге сатып алу жіберілді',
      'ORAL_ORDER_REFUND': 'Oral Gateway-ге қайтарым жіберілді',
      'WHATSAPP_NOTIFICATION_CREATED': 'whatsapp хабарламасы құрылды'
    },
    'faq-list': {
      'answer': 'Жауап',
      'answerHelpful': 'жауапты пайдалы деп санайды',
      'isAnswerHelpfulForYou': 'Сіз үшін жауап пайдалы болды',
      'no': 'Жоқ',
      'search': 'Іздеу',
      'title': 'FAQ',
      'yes': 'Иә'
    },
    'feedback': {
      'confirmRemove': 'Пікірді шынымен жойғыңыз келе ме?'
    },
    'file-list': {
      'ng': {
        'delete': 'Файлды жою',
        'file': 'Уақытша файл',
        'success': '{{ file }} ({{ date }} жүктелген, Астана уақыты)'
      }
    },
    'file-upload': {
      'mb': 'МБ',
      'size': 'Максималды өлшем'
    },
    'form': {
      'fillRequiredFields': 'Міндетті өрістерді толтырыңыз'
    },
    'gis-address': {
      'address': 'Мекенжайды көрсетіңіз',
      'btn': {
        'address': 'Терілген мекенжайды көрсету',
        'refusal': 'Бас тарту'
      },
      'delivery-zone': 'Жеткізу аймағы',
      'flat': 'пәтер',
      'floor': 'қабат',
      'noDelivery': 'Жеткізбейміз',
      'noFind': 'Мекенжай табылмады',
      'p': 'к',
      'search': 'Іздеу…',
      'shop': 'Дүкен',
      'showMap': 'Картаны көрсету',
      'startText': 'Теруді бастаңыз',
      'text': 'мекенжайға жеткізбейді'
    },
    'hx-loader': {
      'noData': 'Дерек жоқ'
    },
    'invoice-select': {
      'from': 'берілген',
      'placeholder': {
        'chooseInvoice': 'Жүкқұжатты таңдаңыз'
      }
    },
    'lang': {
      'en': 'Ағылшынша',
      'kk': 'Қазақша',
      'ru': 'Орысша',
      'us': 'Ағылшынша'
    },
    'loading': {
      'create': {
        'finished': 'Тапсырысты құруды аяқтап жатырмыз',
        'order': 'Тапсырыс құрып жатырмыз'
      },
      'order': {
        'send': 'Тапсырысты жіберіп жатырмыз'
      },
      'save': 'Деректер сақталып жатыр…'
    },
    'manual-address': {
      'address': 'Жеткізу мекенжайы',
      'flat': 'пәтер',
      'floor': 'қабат',
      'p': 'к'
    },
    'modal-user': {
      'birthDate': 'Туған күні',
      'client': 'Клиент',
      'mobile': 'Ұялы телефон',
      'user': 'Пайдаланушы'
    },
    'no': 'Жоқ',
    'nt': {
      'saved': 'Деректер сақталды'
    },
    'operationDayClosed': 'Операциялық күн жабылды',
    'order-event-list': {
      'ts': {
        'noFindList': 'Бас тарту тапсырысы табылмады, техникалық қолдауға хабарласыңыз',
        'orderCancel': 'Бас тарту тапсырысы табылмады, тапсырыс төленген-төленбегенін тексеріңіз'
      }
    },
    'order-receipt': {
      'ofd': 'ФДО',
      'checkSite': 'түбіртекті тексеру үшін келесі сайтқа өтіңіз',
      'address': 'Жеткізу мекенжайы',
      'cancellation': 'Бас тарту себебі',
      'cashier': 'Кассир',
      'check': 'Түбіртек',
      'checkHidden': 'Түбіртек басылды',
      'client': 'Тұтынушы',
      'footer': '© Happy Tech App',
      'ng': {
        'courier': 'Жеткізуші'
      },
      'noCheck': 'ТҮБІРТЕКСІЗ',
      'note': 'Ескертпе',
      'paid': 'Сатып алғаныңыз үшін рахмет!',
      'paidMethod': 'Төлем әдісі',
      'printCheck': 'Түбіртек басу',
      'printedCheck': 'Түбіртек басылды',
      'return': 'Қайтару',
      'series': 'ҚҚС Сериясы',
      'table': {
        'body': {
          'discount': 'Жеңілдіктер',
          'text': 'соның ішінде ҚҚС: 12%',
          'total': 'Жалпы',
          'totalAll': 'БАРЛЫҒЫ'
        },
        'head': {
          'name': 'Тауар атауы',
          'num': 'Саны',
          'sum': 'Сома',
          'weight': 'Салмағы'
        }
      },
      'text-1': 'ККТ ЗН',
      'text-10': 'ҚҚС Сериясы',
      'text-11': 'Салық режимі',
      'text-2': 'ККТ РН',
      'text-3': 'ФН',
      'text-4': 'ФД',
      'text-5': 'ФП',
      'text-6': 'Чек',
      'text-7': 'Күні',
      'text-8': 'Ауысым',
      'text-9': 'ФНС сайты',

      'thanks': 'Сатып алғаныңыз үшін рахмет!',
      'timeDelivery': 'Жеткізу уақыты',
      'timePickup': 'Өзі алып кету уақыты',
      'user': 'Алушы',
      'vat-amount': 'ҚҚС сомасы 5%'
    },
    'order-refunded-list': {
      'from': 'берілген',
      'table': {
        'body': {
          'allTotal': 'Барлығы',
          'discount': 'Жеңілдіктер',
          'total': 'Барлығы'
        },
        'head': {
          'name': 'Атауы',
          'num': 'Саны',
          'price': 'Баға',
          'sum': 'Сома',
          'weight': 'Салмағы'
        }
      }
    },
    'paidOrderChangeForbidden': 'Төленген тапсырыста бағаны өзгертуге болмайды',
    'pickups': {
      'notfound': 'Өзі алып кету уақыты табылмады'
    },
    'product-info-select': {
      'placeholder': {
        'loading': 'Ізделуде…',
        'name': 'Атауын енгізіңіз',
        'noFind': 'Табылмады',
        'search': 'Іздеу үшін теруді бастаңыз'
      }
    },
    'product-list': {
      'alert': 'Таңдалған күнге безендіру өшірілген',
      'autoDeliveryInfo': 'Мекенжай көрсетілгенде жеткізу қосылады',
      'btn': {
        'divide': 'Бөлу',
        'refusal': 'Бас тарту'
      },
      'decorationDisabled': 'Таңдалған күнге безендіру өшірілген',
      'hiddenCategories': 'Жасырылған санаттар',
      'hideCategory': 'Санатты жасыру',
      'notAbleToReserve': '{{title.ru}} - тапсырысты қабылдау үшін ең аз күн саны: {{minOrderDay}}, {{receiveAfterTime}} кейін сатылады',
      'notAbleToReserveUntil': '{{title.ru}} - тапсырысты қабылдау үшін ең аз күн саны: {{minOrderDay}}, {{untilOrderTime}} дейін қабылданады, {{receiveAfterTime}} кейін сатылады',
      'productListEmpty': 'Торттар тізімі бос',
      'productNotForSale': 'Өнім сатылмайды',
      'receiveAfterTime': '{{title.ru}} {{receiveAfterTime}} кейін сатылымға шығады',
      'reserveNoFreeProduct': 'Брондау мүмкін емес. Бос өнімдер жоқ',
      'showCategory': 'Санатты көрсету',
      'ts': {
        'noChoose': 'Санат және/немесе күн таңдалмаған'
      }
    },
    'receipt': {
      'fiscalCheck': 'Фискалды түбіртек',
      'fiscalization': 'Фискалдандыру',
      'offlineMode': 'Түбіртек автономды режимде құрылды',
      'wkCashboxFactoryNumber': 'МЗН',
      'wkCashboxIdentificationNumber': 'КИН ФДО',
      'wkCashboxRegistrationNumber': 'МТН',
      'wkFiscalDate': 'Күні',
      'wkFiscalNumber': 'ФБ'
    },
    'rejection-list': {
      'address': 'Мекенжай',
      'btn': {
        'search': 'іздеу'
      },
      'city': 'Қала',
      'data': 'Күні',
      'delivery': 'Жеткізу',
      'failures': 'Бас тартулар',
      'pickup': 'Өзі алып кету',
      'placeholder': {
        'chooseCity': 'Қаланы таңдау',
        'name': 'Аты-жөні немесе телефон нөмірі'
      },
      'products': 'Өнімдер',
      'promo': 'Промо',
      'registration': 'Безендіру',
      'searchAddress': 'Мекенжай бойынша іздеу',
      'shop': 'Дүкен',
      'table': {
        'head': {
          'absent': 'жоқ',
          'address': 'Мекенжайлар',
          'city': 'Қала',
          'client': 'Клиент',
          'data': 'Күні',
          'delivery': 'Жеткізу',
          'note': 'Ескертпе',
          'order': 'Тапсырыс ID',
          'pickup': 'Өзі алып кету',
          'products': 'Өнімдер',
          'promo': 'Промо',
          'registration': 'Безендіру',
          'shop': 'Дүкен',
          'timeCreate': 'Құрылған уақыты'
        }
      }
    },
    'select': {
      'category': 'Санатты таңдаңыз'
    },
    'sms-info-modal': {
      'send': 'Провайдерге жіберілді',
      'sendClient': 'Клиентке жіберілді',
      'title': 'СМС туралы ақпарат'
    },
    'sms': {
      'status': {
        'ACCEPTED': 'хабарлама қабылданды деген күйде тұр, яғни абонент атынан клиент қызметі оны қолмен оқыды',
        'DELETED': 'хабарлама жойылды',
        'DELIVERED': 'жеткізілді',
        'EXPIRED': 'СМС өмір сүру мерзімі өтті',
        'FAILED': 'СМС орталығының ішкі қатесі',
        'INVALID': 'СМС орталығының ішкі қатесі',
        'NEW': 'құрылды',
        'REJECTED': 'хабарлама қабылданбады, бұл оператор оны жеткізуден бас тартқанда болады',
        'SENT': 'жіберілді',
        'UNDELIVERED': 'жеткізілмеді, себебі кодта'
      }
    },
    'store-search': {
      'placeholder': {
        'loader': 'Ізделуде…',
        'nameSearch': 'Дүкеннің атауын енгізіңіз',
        'noFind': 'Табылмады',
        'startSearch': 'Іздеу үшін теруді бастаңыз'
      }
    },
    'store-select': {
      'placeholder': {
        'chooseShop': 'Дүкенді таңдаңыз'
      }
    },
    'user-search': {
      'placeholder': {
        'loader': 'Ізделуде…',
        'name': 'Пайдаланушының атын немесе телефонын енгізіңіз',
        'noFind': 'Табылмады',
        'search': 'Іздеу үшін теруді бастаңыз'
      }
    },
    'user-select': {
      'placeholder': {
        'loader': 'Ізделуде…',
        'name': 'Пайдаланушының атын немесе телефонын енгізіңіз',
        'noFind': 'Табылмады',
        'search': 'Іздеу үшін теруді бастаңыз'
      }
    },
    'yes': 'Иә'
  }
};
